import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Seo from "./Seo";

function Section({ title, children }) {
  return (
    <section style={{ marginBottom: "1.5rem" }}>
      <h2 style={{ fontSize: "1.1rem", fontWeight: 600, marginBottom: "0.4rem" }}>{title}</h2>
      <p style={{ margin: 0, lineHeight: 1.7 }}>{children}</p>
    </section>
  );
}

function TermsOfUse() {
  const { t } = useTranslation();

  return (
    <Container style={{ paddingTop: 32, paddingBottom: 64, maxWidth: 760 }}>
      <Seo
        title={t("termsOfUse.pageTitle")}
        description={t("termsOfUse.pageDesc")}
        canonical="/terms-of-use"
      />
      <h1 style={{ marginBottom: "0.25rem" }}>Terms of Use</h1>
      <p style={{ color: "#888", marginBottom: "2rem", fontSize: "0.9rem" }}>Last updated: May 2026</p>

      <Section title="1. Acceptance of Terms">
        By accessing or using aitradingpredictions.com (the "Site"), you agree to be bound by these
        Terms of Use. If you do not agree with any part of these terms, please do not use the Site.
      </Section>

      <Section title="2. Informational and Educational Purpose Only">
        All content published on this Site — including sentiment scores, market analysis, directional
        signals, articles, and commentary — is provided for informational and educational purposes
        only. Nothing on this Site constitutes financial advice, investment advice, trading
        recommendations, or any form of personalised financial guidance. You should not treat any
        content on this Site as a substitute for professional financial advice.
      </Section>

      <Section title="3. Not a Regulated Financial Service">
        A.I. Trading Predictions is not a registered investment advisor, broker-dealer, or financial
        services provider under any applicable law. No content on this Site should be interpreted as
        a solicitation or recommendation to buy, sell, or hold any financial instrument, security, or
        digital asset.
      </Section>

      <Section title="4. AI-Generated Content">
        Sentiment scores and signals are generated by automated artificial intelligence models that
        analyse news and market information. AI-generated outputs are inherently subject to error,
        bias, and limitations. You should not rely solely on AI-generated content when making
        financial decisions.
      </Section>

      <Section title="5. No Warranty on Accuracy">
        While we strive to provide timely and accurate information, we make no representations or
        warranties — express or implied — regarding the accuracy, completeness, reliability, or
        timeliness of any content on this Site. Market conditions can change rapidly, and information
        may become outdated without notice.
      </Section>

      <Section title="6. Past Performance">
        Any historical sentiment data, performance statistics, or signal outcomes shown on this Site
        are provided for illustrative purposes only. Past performance is not indicative of future
        results. No signal or sentiment reading should be interpreted as a guarantee of future market
        direction or trading profitability.
      </Section>

      <Section title="7. Risk Warning">
        Trading financial instruments — including currencies, metals, indices, cryptocurrencies, and
        commodities — carries a high level of risk and may not be suitable for all individuals. You
        may lose some or all of your invested capital. Never trade with money you cannot afford to
        lose. Always consult a qualified, licensed financial advisor before making trading or
        investment decisions.
      </Section>

      <Section title="8. Limitation of Liability">
        To the fullest extent permitted by applicable law, A.I. Trading Predictions, its operators,
        contributors, and affiliates shall not be liable for any direct, indirect, incidental,
        consequential, or special losses or damages arising from your use of the Site, including any
        trading losses or financial decisions made in reliance on content published here.
      </Section>

      <Section title="9. Third-Party Information">
        Sentiment analysis on this Site is derived in part from third-party news sources. We have no
        control over the accuracy, completeness, or reliability of third-party content. References to
        external sources do not constitute endorsement of those sources or their views.
      </Section>

      <Section title="10. Changes to These Terms">
        We reserve the right to modify these Terms of Use at any time without prior notice. Continued
        use of the Site following any changes constitutes your acceptance of the revised terms. The
        "Last updated" date at the top of this page reflects when the most recent revision was made.
      </Section>

      <Section title="11. Governing Law">
        These Terms of Use are governed by the applicable laws of the jurisdiction in which you
        reside. If any provision of these Terms is found to be invalid or unenforceable, the
        remaining provisions shall continue in full force and effect.
      </Section>
    </Container>
  );
}

export default TermsOfUse;
